// extracted by mini-css-extract-plugin
export default {"signatureField":"uNKcL0","header":"yuwK8l","inputContainer":"gMbsoS"};